import { useTranslation } from 'react-i18next';
import { brand } from '../config/brand';

interface PricingPlan {
  name: string;
  price: string;
  unit: string;
  badge?: string;
  features: string[];
  highlighted?: boolean;
}

interface PricingCategory {
  id: string;
  title: string;
  plans: PricingPlan[];
}

export function PricingSection() {
  const { t } = useTranslation();
  const categories = t('pricing.categories', { returnObjects: true }) as PricingCategory[];

  return (
    <section id="pricing" className="pricing-section">
      <div className="container">
        <header className="section-heading">
          <h2>{t('pricing.title')}</h2>
          <p>{t('pricing.subtitle')}</p>
        </header>
        {categories.map((cat) => (
          <div key={cat.id} className="pricing__category">
            <h3 className="pricing__category-title">{cat.title}</h3>
            <div className="pricing__grid">
              {cat.plans.map((plan, i) => (
                <div
                  key={i}
                  className={`pricing-card ${plan.highlighted ? 'pricing-card--highlighted' : ''}`}
                >
                  {plan.badge && <span className="pricing-card__badge">{plan.badge}</span>}
                  <h4 className="pricing-card__name">{plan.name}</h4>
                  <div className="pricing-card__price">
                    <span className="pricing-card__amount">{plan.price}</span>
                    <span className="pricing-card__unit">/{plan.unit}</span>
                  </div>
                  <ul className="pricing-card__features">
                    {plan.features.map((f, j) => (
                      <li key={j}>{f}</li>
                    ))}
                  </ul>
                  <a
                    href={brand.contact.whatsapp}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`button ${plan.highlighted ? 'button--primary' : 'button--ghost'}`}
                  >
                    {t('pricing.cta')}
                  </a>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
